/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUpdateMyHomeStatusRequest {
  /** ID объекта **/
  myHomeId: number;
  /** Статус объекта **/
  status: EStatus;
}

export enum EStatus {
  /** Не выбрано **/
  'NotSelected' = 'notSelected',
  /** Хочу продать **/
  'NeedSale' = 'needSale',
  /** Сдаю длительно или планирую сдавать **/
  'RentOrNeedRent' = 'rentOrNeedRent',
  /** Сдаю посуточно или планирую сдавать **/
  'DailyRentOrNeedRent' = 'dailyRentOrNeedRent',
  /** Решаю, сдавать или продавать **/
  'ThinkRentOrSale' = 'thinkRentOrSale',
  /** Прикидываю, сколько получу от продажи **/
  'WantKnowSalePrice' = 'wantKnowSalePrice',
  /** Попросили оценить **/
  'SomebodyWantKnowPrice' = 'somebodyWantKnowPrice',
  /** Инвестирую в этот объект **/
  'Investment' = 'investment',
  /** Хочу купить **/
  'WantToBuy' = 'wantToBuy',
  /** Просто интересуюсь **/
  'Other' = 'other',
}
